/* External */
import { all } from "redux-saga/effects";

/* Services */
import { backendService } from "../../../services";

/* Others */
import { ACTION_TYPES_BASE_NAME } from "./actions";
import { getPlaybackUrl, makeFetchSaga } from "../../../utils";

const fetchEntitlementsTokenSaga = makeFetchSaga(
  ACTION_TYPES_BASE_NAME,
  {
    func: backendService.entitlement.getEntitlementToken,
    getParams: ({ assetId, isLive }, state) => {
      const {
        player: {
          asset: { data: asset }
        },
        user: {
          account: { uid: userId },
          deviceId
        }
      } = state;

      return [
        userId,
        {
          tokenType: "isp-atlas",
          assetID: assetId,
          playbackUrl: getPlaybackUrl(isLive ? asset.liveURLs : asset.vodURLs),
          deviceId,
          capabilities: { widevineSecurityLevel: "L3" }
        }
      ];
    }
  },
  (data) => data?.token
);

export default function* () {
  yield all([fetchEntitlementsTokenSaga]);
}
